import { useState, useCallback } from "react";
import { sendLead } from "./sendLead";
import { isNameValid, isPhoneValid } from "./phone";

// Общая логика отправки формы-заявки: валидирует поля, шлёт, хранит статус и ошибки.
// status: "idle" | "sending" | "success" | "error".
// errors: { name?, phone? } — ошибки конкретных полей (свои, без браузерных).
export default function useLeadSubmit(source) {
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(""); // общая ошибка (сеть/сервер)
  const [errors, setErrors] = useState({}); // ошибки полей

  const submit = useCallback(
    async (e, onSuccess) => {
      e.preventDefault();
      if (status === "sending") return;

      const form = e.currentTarget;
      const fd = new FormData(form);
      const name = (fd.get("name") || "").toString().trim();
      const phone = (fd.get("phone") || "").toString().trim();
      const service = (fd.get("service") || "").toString().trim();
      const consent = fd.get("consent") === "on"; // чекбокс согласия

      // Валидация (без нативных браузерных подсказок).
      const fieldErrors = {};
      if (!isNameValid(name)) fieldErrors.name = "Введите имя (от 2 букв)";
      if (!isPhoneValid(phone)) fieldErrors.phone = "Введите телефон полностью";
      if (!consent) fieldErrors.consent = "Необходимо согласие на обработку персональных данных";
      if (Object.keys(fieldErrors).length) {
        setErrors(fieldErrors);
        setStatus("idle");
        return;
      }

      setErrors({});
      setStatus("sending");
      setError("");

      const res = await sendLead({
        name,
        phone,
        service,
        source: source || "",
        page: typeof window !== "undefined" ? window.location.pathname : "",
      });

      if (res.ok) {
        setStatus("success");
        form.reset();
        if (onSuccess) onSuccess();
      } else {
        setStatus("error");
        setError(res.error);
      }
    },
    [status, source]
  );

  // Сбросить ошибку конкретного поля (при исправлении ввода).
  const clearFieldError = useCallback((field) => {
    setErrors((prev) => (prev[field] ? { ...prev, [field]: undefined } : prev));
  }, []);

  return { status, error, errors, submit, clearFieldError, reset: () => setStatus("idle") };
}
